import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

// Components
import CountIndicator from '../../../../components/misc/CountIndicator';
import Icon from '../../../../components/icons/Icon';

// Selectors
import { newNotificationsCountSelector } from '../../../../workspace/header/workspaceToolsHeader/notifications/notificationsUtilSelector';

const MobileNotificationsUtil = (): ReactElement => {
    const newNotificationsCount = useSelector(newNotificationsCountSelector);

    return (
        <div className="MobileNotificationsUtil">
            <CountIndicator count={newNotificationsCount} badge />
            <Icon name="mobile-toolbar-notifications" />
            <div className="label">Notifications</div>
        </div>
    );
};

export default MobileNotificationsUtil;
